export const postsGrid = () => {

	const postsContainers = document.querySelectorAll(".blog__posts-wrapper");

	if (!postsContainers)
		return;

	let containersSizeObserver = null;

	const observedPostsContainer = () =>
	{
		containersSizeObserver = new ResizeObserver((entries) =>
		{
			entries.forEach((entry) =>
			{
				if (entry.contentBoxSize)
				{
					let container = entry.target;

					// console.log(container);
					const postsTiles = container.querySelectorAll(".last-posts-block.last-posts-block--left");
					const bgElement = container.querySelector(".blog__posts-background");

					if (bgElement && postsTiles)
					{
						const firstPostTile = postsTiles[0];

						if (firstPostTile)
						{
							const containerBox = container.getBoundingClientRect();
							const firstPostTileBox = firstPostTile.getBoundingClientRect();

							const bgHeight = Math.max(0, (firstPostTileBox.bottom - containerBox.top - 100))

							bgElement.style.height = bgHeight + "px";
						}
					}
				}
			});
		});

		postsContainers.forEach((element) =>
		{
			containersSizeObserver.observe(element);
		});
	};

	observedPostsContainer();
};
